import type { FC } from "react";
import { FiSearch } from "react-icons/fi";

interface SearchProps {
  className?: string;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
}

const SearchBar: FC<SearchProps> = ({
  className,
  searchTerm,
  setSearchTerm,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div
      className={`flex px-3 py-2 items-center bg-field-bg rounded-lg font-medium ${className}`}
    >
      <FiSearch className="w-5 h-5 text-tertiary-text" />
      <input
        className="bg-transparent outline-none placeholder-tertiary-text flex-grow px-4 rounded-r-lg"
        type="text"
        placeholder="Filter by name and vote address"
        value={searchTerm}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchBar;
